/**************************************************
 * Nombre:       Profesional_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Chip, Grid, Typography} from "@mui/material";
import servicio from '../../../Recursos/foto_profesional.png'

const Profesional_Detalle = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            backgroundColor: 'white',
                            borderRadius: 5,

                        }}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}
                            sx={{p: 6}}
                        >

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={2}
                                sx={{mt: 0}}
                            >

                                {/*} <Chip color={'primary'} label={'Cosejero Juvenil'} sx={{fontWeight: 600}}/>

                                <Chip color={'primary'} label={'Cosejero Pareja'} sx={{fontWeight: 600}}/> */}

                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                                <Typography sx={{fontSize: 40, fontWeight: 800, lineHeight: 1.1}}>Mauricio Nicolás
                                    Battafarano</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 2}}>
                                <Typography sx={{fontSize: 18, fontWeight: 400}}>
                                    Médico, diploma de honor de la Universidad de Buenos Aires, doctor en medicina y
                                    cirugía., máster en psico-neuro-inmuno-endocrinología, especialista en psiquiatría,
                                    psicología clínica y neurocirugía, profesor universitario. International
                                    Distinguished Fellow de la American Psychiatry Association. Autor de libros y
                                    publicaciones nacionales e internacionales. Miembro fundador del Centro Viktor
                                    Frankl para la Difusión de la Logoterapia (Buenos Aires).
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                {/*} <Chip color={'secondary'} label={'$ 8.000/Hr'} sx={{fontWeight: 800, pt: 0.1}}/>*/}
                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <img src={servicio} width={'100%'} height={'auto'} style={{
                                borderTopRightRadius: 30,
                                borderBottomRightRadius: 30
                            }}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Profesional_Detalle